import {
    Button,
    Grid,
    Card,
    IconButton,
    InputAdornment,
    Menu,
    MenuItem,
    TextField,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ReplayIcon from "@mui/icons-material/Replay";
import AddIcon from "@mui/icons-material/Add";
import { AccessLgo, LogIcon, ManageIcon, RefreshLogo } from "../Layout/Svg";
import MyTable from "../Schedule/MyTable";
import { useNavigate } from "react-router-dom";
import PermissionModal from "./PermissionModal";
import { useSnackbar } from "notistack";
import { toast } from 'react-toastify';
import ApiService from "../../functions/apiService";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AuthContext from "../../context/AuthContext";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EmptyState from "../Error/EmptyState";
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Pagination from '@mui/material/Pagination';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";
import ButtonTheme from "../ThemeButton/ThemeButton";
import UpdateModal from "./UpdateModal";
import { Pages } from "@mui/icons-material";

export function MyTeamTable({ row, columns, filter = "", loadData = {} }) {
    const { permission, pages } = useContext(AuthContext);
    // const { enqueueSnackbar } = useSnackbar();
    const [searchText, setSearchText] = useState("");
    const [selectedRow, setSelectedRow] = useState();
    const [windowSize, setWindowSize] = useState(1);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [contextMenu, setContextMenu] = useState(null);
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [show, setShow] = useState(false);

    const handleOpenModal = () => setOpen(true);
    const handleCloseModal = () => setOpen(false);
    const handleClose2 = () => { setShow(false) }

    let removeEmp = (empIds) => {
        setRowSelectionModel((pre) => {
            const index = pre.indexOf(empIds);
            if (index > -1) {
                pre.splice(index, 1);
            }
            return pre;
        });
    };
    useEffect(() => {
        setWindowSize(window.innerWidth);
        // addEventListener("resize", (event) => {
        //     setWindowSize(window.innerWidth);
        // });
    }, []);

    const mangeAuthority = (single = true) => {
        if (rowSelectionModel && rowSelectionModel.length > 0) {
            handleOpenModal();
        } else {
            if (single) {
                setRowSelectionModel([selectedRow]);
                handleOpenModal();
            } else {
                toast.warning("Must Select")
                // enqueueSnackbar("Must Select", { variant: "warning" });
            }
        }
        handleClose();
    };

    let navigate = useNavigate();
    const res = useMemo(() => {
        return row.employees.filter((x) => {
            return x.employee?.fullName
                .toLowerCase()
                .includes(searchText.toLowerCase());

        });
    }, [searchText, row]);

    const handleContextMenu = (event) => {
        event.preventDefault();
        let selectedId = Number(event.currentTarget.getAttribute("data-id"));
        setSelectedRow(selectedId);
        setRowSelectionModel((pre) => {
            return [...pre, selectedId];
        });
        setContextMenu(
            contextMenu === null
                ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
                : null
        );
    };

    const rowOptions = {
        row: {
            onContextMenu: handleContextMenu,
            style: { cursor: "context-menu" },
        },
    };

    const handleClose = () => {
        setContextMenu(null);
    };

    const memberLog = () => {
        if (selectedRow) {
            navigate("/firehouse/employeeLog/" + selectedRow);
        } else {
            toast.warning("Please select a member first!")
            // enqueueSnackbar("Please select a member first!", { variant: "warning" });
        }
    };

    const editEmployee = () => {
        if (selectedRow) {
            navigate("/firehouse/employee?empId=" + selectedRow);
        } else {
            toast.warning("Please select a member first!")
            // enqueueSnackbar("Please select a member first!", { variant: "warning" });
        }
    };

    const addEmployee = () => {
        navigate("/firehouse/employee");
    };

    const resetPassword = async (type, single = true) => {
        let ids = [];
        if (rowSelectionModel.length > 0) {
            single = false;
            ids = rowSelectionModel;
        } else {
            if (single) {
                ids = [selectedRow];
            } else {
                if (rowSelectionModel && rowSelectionModel.length) {
                    ids = rowSelectionModel;
                } else {
                    toast.warning("Must select")
                    // enqueueSnackbar("Must Select", { variant: "warning" });
                    return;
                }
            }
        }
        ApiService.post("/resetPasswordEmployee", {
            EmpIds: rowSelectionModel,
            type: type,
				}).then((data) => {
					toast.success("Password Reset Successful")
					// toast.success(`${rowSelectionModel.length} member(s) disabled`)
					loadData()
        });
        // handleClickMobile();
    };

    const onRowSelectionModelChange = (newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
        if (newRowSelectionModel.length > 0) {
            setSelectedRow(
                newRowSelectionModel[newRowSelectionModel.length - 1]
            );
        } else {
            setSelectedRow();
        }
    };

    const handleClickMobile = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMobile = () => {
        setAnchorEl(null);
    };

    const multiDelete = async () => {
        ApiService.post("/deleteMultipleEmployees", {
            Emp_Codes: rowSelectionModel,
        }).then((data) => {
            loadData()
            setDeleteModal(false)
            toast.success("Deleted Successfully");
        });
    };

    return (
        <div>
            <div className="mx-1 px-1 pt-2 row">
                <div className="col-2">
                    <Typography style={{ fontSize: '16px', fontWeight: '520', marginTop: '10px' }}>{row.name}</Typography>
                </div>
                {/* <div className="col-12 col-md-2 col-lg-2">
                    <TextField
                        onChange={(event) => setSearchText(event.target.value)}
                        variant="standard"
                        placeholder="Search"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div> */}
                {windowSize <= 800 && (
                    <div className="col-12 col-md-12 col-lg-10 text-end">
                        <Button
                            className="my-3"
                            id="demo-positioned-button"
                            aria-controls={
                                open ? "demo-positioned-menu" : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={handleClickMobile}
                        >
                            Actions <KeyboardArrowDownIcon />
                        </Button>
                        <Menu
                            id="demo-positioned-menu"
                            aria-labelledby="demo-positioned-button"
                            anchorEl={anchorEl}
                            open={anchorEl}
                            onClose={handleCloseMobile}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                        >
                            {permission && permission.includes("Auth_Auth") && (
                                <MenuItem onClick={() => mangeAuthority(false)}>
                                    Manage Authorities
                                </MenuItem>
                            )}
                            <MenuItem onClick={memberLog} >Member Log</MenuItem>
                            {permission && permission.includes("Emp_Auth") && (
                                <MenuItem onClick={addEmployee}>Add</MenuItem>
                            )}
                            {permission && permission.includes("Emp_Auth") && (
                                <MenuItem
                                    disabled={rowSelectionModel.length > 1}
                                    onClick={editEmployee}

                                >
                                    Edit
                                </MenuItem>
                            )}
                            {permission &&
                                permission.includes("Emp_Auth") &&
                                permission.includes("Pass_Auth") && (
                                    <MenuItem
                                        onClick={() =>
                                            resetPassword("DISABLE", false)
                                        }
                                    >
                                        Revoke Access
                                    </MenuItem>
                                )}
                            {permission &&
                                permission.includes("Emp_Auth") &&
                                permission.includes("Pass_Auth") && (
                                    <MenuItem
                                        onClick={() =>
                                            resetPassword("RESET", false)
                                        }
                                    >
                                        Reset Password
                                    </MenuItem>
                                )}
                            {permission &&
                                permission.includes("Emp_Auth") &&
                                permission.includes("Pass_Auth") &&
                                pages.includes("V3_SENIORITY_FORCE_UPDATE") && (
                                    <MenuItem
                                        onClick={() => { setShow(true) }}
                                    >
                                        Refresh Seniority
                                    </MenuItem>
                                )}
                        </Menu>
                    </div>
                )}
                {windowSize > 800 && (
                    <div className="col-8 col-md-12 col-lg-10 text-end" style={{ marginBottom: '-6px' }}>
                        {permission && permission.includes("Auth_Auth") && (
                            <button
                                disabled={!selectedRow}
                                className="bg-transparent border-0 my-1"
                            >
                                <span
                                    onClick={() => mangeAuthority(false)}
                                    className="me-1 d-flex "
                                >
                                    <ManageIcon height={20} width={20} />
                                    <p
                                        className={`mx-1`}
                                        style={{ whiteSpace: "nowrap", fontSize: '12px', fontWeight: '550' }}
                                    >
                                        Manage Authorities
                                    </p>
                                </span>
                            </button>
                        )}
                        <button
                            disabled={
                                !selectedRow
                                    ? true
                                    : rowSelectionModel.length > 1
                                        ? true
                                        : false
                            }
                            onClick={memberLog}
                            className={` bg-transparent border-0 my-1`}
                        >
                            <span className="me-1 d-flex ">
                                <LogIcon height={20} width={20} />
                                <p
                                    className={`mx-1`}
                                    style={{ whiteSpace: "nowrap", fontSize: '12px', fontWeight: '550' }}
                                >
                                    Member Log
                                </p>
                            </span>
                        </button>
                        {permission && permission.includes("Emp_Auth") && (
                            <>
                                <button
                                    disabled={!selectedRow ? true : rowSelectionModel.length > 1 ? true : false}
                                    onClick={editEmployee}
                                    className="bg-transparent border-0 my-1"
                                >
                                    <span className="me-1 d-flex ">
                                        <BorderColorIcon color="secondary" height={16} width={16} />
                                        <p className={`mx-1 mt-1`} style={{ whiteSpace: "nowrap", fontSize: '12px', fontWeight: '550' }}>
                                            Edit
                                        </p>
                                    </span>
                                </button>
                                <button disabled={!selectedRow} onClick={() => setDeleteModal(true)} className="bg-transparent border-0 my-1">
                                    <span className="me-1 d-flex ">
                                        <DeleteOutlineOutlinedIcon color="secondary" height={22} width={22} />
                                        <p className={`mx-1 mt-1`} style={{ whiteSpace: "nowrap", fontSize: '12px', fontWeight: '550' }}>
                                            Delete
                                        </p>
                                    </span>
                                </button>
                                <button onClick={addEmployee} className="bg-transparent border-0 my-1">
                                    <span className="me-1 d-flex ">
                                        <AddIcon color="secondary" height={20} width={20} />
                                        <p className={`mx-1 mt-1`} style={{ whiteSpace: "nowrap", fontSize: '12px', fontWeight: '550' }}>
                                            Add
                                        </p>
                                    </span>
                                </button>
                            </>
                        )}
                        {permission &&
                            permission.includes("Emp_Auth") &&
                            permission.includes("Pass_Auth") && (
                                <>
                                    <button disabled={!selectedRow}
                                        onClick={() =>
                                            resetPassword("RESET", false)
                                        }
                                        className="bg-transparent border-0 my-1"
                                    >
                                        <span className="me-1 d-flex ">
                                            <ReplayIcon color="secondary" height={18} width={18} />
                                            <p className={`mx-1 mt-1`} style={{ whiteSpace: "nowrap", fontSize: '14px' }}>
                                                Reset Password
                                            </p>
                                        </span>
                                    </button>
                                    <button
                                        disabled={!selectedRow}
                                        onClick={() =>
                                            resetPassword("DISABLE", false)
                                        }
                                        className="bg-transparent border-0 my-1"
                                    >
                                        <span className="me-1 d-flex ">
                                            <AccessLgo height={20} width={20} />
                                            <p className={`mx-1`} style={{ whiteSpace: "nowrap", fontSize: '14px' }}>
                                                Revoke Access
                                            </p>
                                        </span>
                                    </button>
                                </>
                            )}
                        {pages.includes('V3_SENIORITY_FORCE_UPDATE') &&
                            <button
                                onClick={() => { setShow(true) }}
                                className="bg-transparent border-0 my-1"
                            >
                                <span className="me-1 d-flex ">
                                    <RefreshLogo height={18} width={18} />
                                    <p className={`mx-1`} style={{ whiteSpace: "nowrap", fontSize: '14px' }}>
                                        Refresh Seniority
                                    </p>
                                </span>
                            </button>
                        }
                    </div>
                )}
            </div>


            <div className="hide-header-checkbox-page">
                <MyTable
                    onRowSelectionModelChange={onRowSelectionModelChange}
                    disableRowSelectionOnClick={false}
                    componentsProps={rowOptions}
                    rows={res}
                    columns={columns}
                    selectedRows={rowSelectionModel}
                    perPage={10}
                    rowCount={res.length}
                />
            </div>


            <Menu
                sx={{
                    ".MuiPopover-paper": {
                        maxHeight: "unset",
                        ".MuiList-padding": {
                            paddingTop: "0px !important",
                            paddingBottom: "0px !important",
                        },
                    },
                }}
                open={contextMenu !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
                componentsProps={{
                    root: {
                        onContextMenu: (e) => {
                            e.preventDefault();
                            handleClose();
                        },
                    },
                }}
            >
                {permission && permission.includes("Auth_Auth") && (
                    <MenuItem className="my-2" onClick={mangeAuthority}>
                        <span className="me-1" style={{ height: "26px" }}>
                            {" "}
                            <ManageIcon />{" "}
                        </span>{" "}
                        Manage Authorities
                    </MenuItem>
                )}
                <MenuItem
                    className="my-2"
                    disabled={rowSelectionModel.length > 1}
                    onClick={memberLog}
                >
                    <span className="me-1" style={{ height: "26px" }}>
                        {" "}
                        <LogIcon />{" "}
                    </span>{" "}
                    Member Log
                </MenuItem>
                {permission && permission.includes("Emp_Auth") && (
                    <MenuItem
                        className="my-2"
                        disabled={rowSelectionModel.length > 1}
                        onClick={editEmployee}
                    >
                        <span className="me-1" style={{ height: "26px" }}>
                            {" "}
                            <BorderColorIcon color="secondary" />{" "}
                        </span>{" "}
                        Edit
                    </MenuItem>
                )}
                {permission &&
                    permission.includes("Emp_Auth") &&
                    permission.includes("Pass_Auth") && (
                        <MenuItem
                            className="my-2"
                            onClick={() => resetPassword("RESET")}
                        >
                            <span className="me-1" style={{ height: "26px" }}>
                                {" "}
                                <ReplayIcon color="secondary" />{" "}
                            </span>{" "}
                            Reset Password
                        </MenuItem>
                    )}
                {permission &&
                    permission.includes("Emp_Auth") &&
                    permission.includes("Pass_Auth") && (
                        <MenuItem
                            className="my-2"
                            onClick={() => resetPassword("DISABLE")}
                        >
                            <span className="me-1" style={{ height: "26px" }}>
                                {" "}
                                <AccessLgo />{" "}
                            </span>{" "}
                            Revoke Access
                        </MenuItem>
                    )}
            </Menu>
            <PermissionModal
                open={open}
                handleCloseModal={handleCloseModal}
                empIds={rowSelectionModel}
                removeEmp={removeEmp}
            />

            <Modal show={show} onHide={() => { setShow(false) }} size="lg">
                <Modal.Body>
                    <UpdateModal
                        show={show}
                        close={() => { setShow(false) }}
                        handleClose={handleClose2}
                        dataLoad={loadData}
                    />
                </Modal.Body>
            </Modal>

            <Modal show={deleteModal} onHide={() => { setDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure to delete this Employee ?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setDeleteModal(false) }}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={multiDelete}>
                                Delete
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </div>
    );
}





export function MyTeamTableCard({ row, columns, filter = "", loadData = {}, show, setShow }) {
    const { permission, pages } = useContext(AuthContext);
    // const { enqueueSnackbar } = useSnackbar();
    const [searchText, setSearchText] = useState("");
    const [selectedRow, setSelectedRow] = useState([]);
    const [windowSize, setWindowSize] = useState(1);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [contextMenu, setContextMenu] = useState(null);
    let navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 10;

    const handleOpenModal = () => setOpen(true);
    const handleCloseModal = () => setOpen(false);
    const handleClose2 = () => { setShow(false) }


    let removeEmp = (empIds) => {
        setRowSelectionModel((pre) => {
            const index = pre.indexOf(empIds);
            if (index > -1) {
                pre.splice(index, 1);
            }
            return pre;
        });
    };

    const mangeAuthority = (single = true, selectedRow) => {
        if (selectedRow) {
            handleOpenModal();
        } else {
            if (single) {
                setSelectedRow([selectedRow]);
                handleOpenModal();
            } else {
                toast.warning("Must Select")
                // enqueueSnackbar("Must Select", { variant: "warning" });
            }
        }
    };

    const res = useMemo(() => {
        return row.employees.filter((x) => {
            return x.employee?.fullName
                .toLowerCase()
                .includes(searchText.toLowerCase());

        });
    }, [searchText, row]);


    const memberLog = (selectedRow) => {
        if (selectedRow) {
            window.open("/firehouse/employeeLog/" + selectedRow, "_blank");
        } else {
            toast.warning("Please select a member first!")
            // enqueueSnackbar("Please select a member first!", { variant: "warning" });
        }
    };

    const editEmployee = (selectedRow) => {
        if (selectedRow) {
            window.open("/firehouse/employee?empId=" + selectedRow, "_blank");
        } else {
            toast.warning("Please select a member first!")
            // enqueueSnackbar("Please select a member first!", {variant: "warning"});
        }
    };

    const resetPassword = async (type, single = true, empId) => {
        let ids = [];
        if (selectedRow) {
            single = false;
            ids = empId;
        } else {
            if (single) {
                ids = [empId];
            } else {
                if (selectedRow) {
                    ids = empId;
                } else {
                    toast.warning("Must Select")
                    // enqueueSnackbar("Must Select", { variant: "warning" });
                    return;
                }
            }
        }
        ApiService.post("/resetPasswordEmployee", {
            EmpIds: [empId],
            type: type,
        }).then((data) => {
            toast.success("Done")
            // enqueueSnackbar("Done", { variant: "success" });
        });
    };

    const multiDelete = async () => {
        ApiService.post("/deleteMultipleEmployees", {
            Emp_Codes: [selectedRow],
        }).then((data) => {
            loadData()
            setDeleteModal(false)
            toast.success("Done")
            // enqueueSnackbar("Done", { variant: "success" });
        });
    };

    const handleClickMobile = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMobile = () => {
        setAnchorEl(null);
    };

    const paginatedData = res.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
    const totalPages = Math.ceil(res.length / ITEMS_PER_PAGE);



    return (
        <div>
            <Grid container>
                <Grid item xs={12} className="mx-3 mt-3">
                    {paginatedData.map((item) => (
                        <Card sx={{ backgroundColor: 'rgba(245, 245, 245, 0.4)', marginBottom: '25px', border: '1px solid #cccccc', borderRadius: '12px' }} elevation={0}>
                            <CardContent>
                                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #cccccc' }}>
                                    <p style={{ fontSize: '16px', fontWeight: '550', fontFamily: 'karla' }}>{item.Effective_Date}</p>
                                    <div style={{ display: 'flex' }}>
                                        {permission && permission.includes("Auth_Auth") && (
                                            <button
                                                className="bg-transparent border-0 my-1"
                                            >
                                                <span
                                                    onClick={() => {
                                                        setSelectedRow(item.employee.Emp_Code);
                                                        mangeAuthority(false, item.employee.Emp_Code);
                                                    }}
                                                    className="me-1 d-flex "
                                                >
                                                    <ManageIcon height={20} width={20} />
                                                    <p
                                                        className={`mx-1`}
                                                        style={{ whiteSpace: "nowrap", fontSize: '14px' }}
                                                    >
                                                        Manage Authorities
                                                    </p>
                                                </span>
                                            </button>
                                        )}
                                        <button
                                            onClick={() => memberLog(item.employee.Emp_Code)}
                                            className={` bg-transparent border-0 my-1`}
                                        >
                                            <span className="me-1 d-flex ">
                                                <LogIcon height={20} width={20} />
                                                <p
                                                    className={`mx-1`}
                                                    style={{ whiteSpace: "nowrap", fontSize: '14px' }}
                                                >
                                                    Member Log
                                                </p>
                                            </span>
                                        </button>
                                        {permission && permission.includes("Emp_Auth") && (
                                            <>
                                                <button
                                                    onClick={() => editEmployee(item.employee.Emp_Code)}
                                                    className="bg-transparent border-0 my-1"
                                                >
                                                    <span className="me-1 d-flex ">
                                                        <BorderColorIcon color="secondary" height={16} width={16} />
                                                        <p className={`mx-1 mt-1`} style={{ whiteSpace: "nowrap", fontSize: '14px' }}>
                                                            Edit
                                                        </p>
                                                    </span>
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        setSelectedRow(item.employee.Emp_Code);
                                                        setDeleteModal(true)
                                                    }}
                                                    className="bg-transparent border-0 my-1">
                                                    <span className="me-1 d-flex ">
                                                        <DeleteOutlineOutlinedIcon color="secondary" height={22} width={22} />
                                                        <p className={`mx-1 mt-1`} style={{ whiteSpace: "nowrap", fontSize: '14px' }}>
                                                            Delete
                                                        </p>
                                                    </span>
                                                </button>
                                            </>
                                        )}
                                        {permission &&
                                            permission.includes("Emp_Auth") &&
                                            permission.includes("Pass_Auth") && (
                                                <>
                                                    <button
                                                        onClick={() => {
                                                            setSelectedRow(item?.employee?.Emp_Code)
                                                            resetPassword("RESET", false, item?.employee?.Emp_Code)
                                                        }}
                                                        className="bg-transparent border-0 my-1"
                                                    >
                                                        <span className="me-1 d-flex ">
                                                            <ReplayIcon color="secondary" height={18} width={18} />
                                                            <p className={`mx-1 mt-1`} style={{ whiteSpace: "nowrap", fontSize: '14px' }}>
                                                                Reset Password
                                                            </p>
                                                        </span>
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setSelectedRow(item?.employee?.Emp_Code)
                                                            resetPassword("DISABLE", false, item?.employee?.Emp_Code)
                                                        }}
                                                        className="bg-transparent border-0 my-1"
                                                    >
                                                        <span className="me-1 d-flex ">
                                                            <AccessLgo height={20} width={20} />
                                                            <p className={`mx-1`} style={{ whiteSpace: "nowrap", fontSize: '14px' }}>
                                                                Revoke Access
                                                            </p>
                                                        </span>
                                                    </button>
                                                </>
                                            )}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                                    <p style={{ fontSize: '18px', fontWeight: '600', fontFamily: 'karla' }}>{item.employee.fullName}</p>
                                    <p style={{ fontSize: '18px', fontWeight: '600', fontFamily: 'karla' }}>User Id - {item.employee.User_id} , {item.employee.Emp_Code}</p>
                                </div>
                                <TableContainer>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((header) => (
                                                    <TableCell
                                                        key={header}
                                                        align="left"
                                                        sx={{
                                                            padding: "0px !important",
                                                            borderBottom: "none !important",
                                                            fontSize: '14px',
                                                            color: '#808080',
                                                            paddingBottom: '16px !important'
                                                        }}
                                                    >
                                                        {header}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.Effective_Date}</TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.employee.Unit_Number}</TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.employee.Badge_Number}</TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.employee.EHd_Seniority}</TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.Group_Code}</TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.StationName}</TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.PositionName}</TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.employee.email}</TableCell>
                                            {columns.includes("Phone") && (
                                                <TableCell
                                                    align="left"
                                                    sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px' }}
                                                >
                                                    {item.employee.Primary_phone}
                                                </TableCell>
                                            )}
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.employee?.Do_Not_Call == 1 ? 'Yes' : 'No'}</TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}></TableCell>
                                            <TableCell align="left" sx={{ padding: "0px !important", borderBottom: "none !important", fontSize: '14px', }}>{item.employee.Hash_Expire}</TableCell>
                                        </TableBody>

                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    ))}
                </Grid>
            </Grid>

            {totalPages > 1 && (
                <Pagination
                    count={totalPages}
                    color="primary"
                    className="mt-3 mb-3 d-flex"
                    style={{ justifyContent: 'end' }}
                    page={currentPage}
                    onChange={(event, page) => setCurrentPage(page)}
                />
            )}

            <PermissionModal
                open={open}
                handleCloseModal={handleCloseModal}
                empIds={[selectedRow]}
                removeEmp={removeEmp}
            />

            <Modal show={show} onHide={() => { setShow(false) }} size="lg">
                <Modal.Body>
                    <UpdateModal
                        show={show}
                        close={() => { setShow(false) }}
                        handleClose={handleClose2}
                        dataLoad={loadData}
                    />
                </Modal.Body>
            </Modal>

            <Modal show={deleteModal} onHide={() => { setDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure to delete this Employee ?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setDeleteModal(false) }}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={multiDelete}>
                                Delete
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </div>
    );
}
